import { render, staticRenderFns } from "./UnidadesList.vue?vue&type=template&id=50d28f54&scoped=true"
import script from "./UnidadesList.vue?vue&type=script&lang=js"
export * from "./UnidadesList.vue?vue&type=script&lang=js"
import style0 from "./UnidadesList.vue?vue&type=style&index=0&id=50d28f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d28f54",
  null
  
)

export default component.exports